<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">The Greek Victories and the Persian Ebb 480–479 <span class="smallcaps">BC</span></h1>
<p class="subtitle">The Battles of Salamis, Plataea, Mycale and after</p>
<p class="author">Manousos E. Kambouris</p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?08a5697c